(function ($) {
     $('.js-pdppack').slick({
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: true,
      prevArrow: '<button class="PDPPack-wrap-prev"><div class="PDPPack-prev-arrow"></div></button>',
    nextArrow: '<button class="PDPPack-wrap-next"><div class="PDPPack-next-arrow"></div></button>',
    dots: false
    });

 

   $(".PDPradio-overlay input").change(function() { 
      if($(this).prop("checked") == true){ 
        $(".PDPradio-overlay input").closest('.PDPAlternate-variant').removeClass('is-selected')
        $(this).closest('.PDPAlternate-variant').addClass('is-selected')
      } 
    })

})(jQuery);


$('.js-product-qty-controls-pdpa').on('click', function(evt) {

    const button = $(evt.delegateTarget)
    var action = button.attr('data-action')
    var field = $('.js-qty-indicator-pdpa')

    var  currentQty = parseInt(field.val())

     updatedQty = (function() {
        if (action === 'plus') {
          return 1 + currentQty
        }
        if (action === 'minus' && currentQty > 1) {

          return currentQty - 1
        }
        return currentQty
      })()

      field.val(updatedQty)
})

/*
$('.js-recharge-fakeautodeliver').hover(function(evt) { 
    evt.preventDefault()
  $('.rc_popup__block').css("display", "block");
}) 

$('.js-recharge-fakeautodeliver').mouseleave(function(evt) { 
    evt.preventDefault()
      $('.rc_popup__block').css("display", "none");
}) 
*/
$('.js-recharge-fakeautodeliver').on('click', function(evt) { 
  evt.preventDefault()
  $('.rc_label__autodeliver').click()
  $('#AddToCart').click()
})  

$('.js-recharge-fakeonetime').on('click', function(evt) { 
  evt.preventDefault()
  $('.rc_label__onetime').click()
  $('#AddToCart').click()
}) 


$(document).ready(function(){
    $('#rc_radio_options input[type="radio"]').change(function(){
        var $this = $(this);
        // Only remove the class in the specific `box` that contains the radio
        $this.closest('#rc_radio_options').find('.rc_block__type').removeClass('highlight');
        $this.closest('.rc_block__type').addClass('highlight');
    });
});